(function ($) {
  $(document).ready(function () {
    $('.aka-block-quote-slider').slick({
      arrows: false,
      autoplay: true,
      autoplaySpeed: 3000,
      adaptiveHeight: false,
      pauseOnFocus: true,
    })
  })
})(jQuery);
